// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_om-0";
export var buttonContainer = "_om-3";
export var cancelButton = "_om-4";
export var headerSection = "_om-6";
export var headerTitle = "_om-9";
export var messageSideLeft = "_om-1";
export var messageSideRight = "_om-2";
export var orderNumberContainer = "_om-7";
export var orderNumberLabel = "_om-8";
export var submitButton = "_om-5";